import { CustomButton } from '@/components/ui/CustomButton';

export const AdviserButton = () => (
  <div className="flex items-center space-x-4 ml-auto">
    {/* Large screen variant */}
    <a href="/professionals/register" className="hidden lg:block lg:w-[6rem] xl:w-full">
      <CustomButton
        variant="primarySmall"
      >
        Register
      </CustomButton>
    </a>

    {/* Small screen variant */}
    <a href="/professionals/register" className="block lg:hidden">
      <CustomButton
        variant="primaryLarge"
      >
        Register
      </CustomButton>
    </a>

    {/* Large screen variant */}
    <a href="https://adviserportal.pureretirement.co.uk/login/" className="hidden lg:block">
      <CustomButton
        variant="secondarySmall"
        className="lg:w-[6rem] xl:w-full"
      >
        Login
      </CustomButton>
    </a>

    {/* Small screen variant */}
    <a href="https://adviserportal.pureretirement.co.uk/login/" className="block lg:hidden">
      <CustomButton
        variant="secondaryLarge"
      >
        Login
      </CustomButton>
    </a>
  </div>
);
